/**
 * @generated SignedSource<<30f1571aaa7cafc2056826c1b1199c1f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef$data = {
  readonly id: string;
  readonly user: {
    readonly accountStatus: AccountStatus;
    readonly name: string;
    readonly picture: AGG$URL;
    readonly " $fragmentSpreads": FragmentRefs<"avatarRelay_UsePictureAndAppTypeFragment">;
  } | null | undefined;
  readonly " $fragmentType": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef";
};
export type singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef$key = {
  readonly " $data"?: singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "singleUserPicker_issueFieldSingleUserPickerReadviewFull_SingleUserPickerReadView_fragmentRef",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        },
        {
          "kind": "ScalarField",
          "name": "picture"
        },
        {
          "kind": "ScalarField",
          "name": "accountStatus"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraaiagentavatarsingleuserpickerrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "avatarRelay_UsePictureAndAppTypeFragment"
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraSingleSelectUserPickerField"
};

(node as any).hash = "2f5cfd29249780f5a332f572f777b4e2";

export default node;
